import { getDesiredAssignmentsSchema } from '../../intune-utlity';
import { buildLapsSettingsSchema } from './helper';
import { DeviceConfigurationWindowsLAPSSchema } from './model';

export const updateSchema = (formValue: any, schema: DeviceConfigurationWindowsLAPSSchema): any => {
    schema.contains.properties.description.const = formValue.policy.description;

    schema.contains.properties.assignments = getDesiredAssignmentsSchema(formValue);

    schema.contains.properties.settings = buildLapsSettingsSchema(formValue.settings);

    return schema;
};
